// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Locale$LumiI18n from "lumi-i18n/lib/es6/src/Locale.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function MakeTitle(P) {
  let NavBar$MakeTitle = props => {
    let locale = Locale$LumiI18n.useContext();
    return JsxRuntime.jsxs("div", {
      children: [
        Stdlib_Option.getOr(props.logo, null),
        P.translate(locale, props.title)
      ],
      className: "navbar-item has-text-weight-bold"
    });
  };
  return {
    make: NavBar$MakeTitle
  };
}

function NavBar(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let match = LumiReact.useActive(() => false);
  let toggleMenu = match.toggle;
  let hideMenu = match.hide;
  let menuActive = match.active;
  let constNull = param => null;
  return JsxRuntime.jsxs("nav", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          Stdlib_Option.getOr(props.brand, null),
          JsxRuntime.jsxs("a", {
            children: [
              JsxRuntime.jsx("span", {}),
              JsxRuntime.jsx("span", {}),
              JsxRuntime.jsx("span", {})
            ],
            className: LumiReact.classList([
              [
                "navbar-burger",
                true
              ],
              [
                "is-active",
                menuActive
              ]
            ]),
            role: "button",
            onClick: param => toggleMenu()
          })
        ],
        className: "navbar-brand"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: Stdlib_Option.getOr(props.start, constNull)(hideMenu),
            className: "navbar-start"
          }),
          JsxRuntime.jsx("div", {
            children: Stdlib_Option.getOr(props.end, constNull)(hideMenu),
            className: "navbar-end"
          })
        ],
        className: LumiReact.classList([
          [
            "navbar-menu",
            true
          ],
          [
            "is-active",
            menuActive
          ]
        ])
      })
    ],
    className: `navbar ` + className,
    role: "navigation"
  });
}

let make = NavBar;

export {
  MakeTitle,
  make,
}
/* LumiReact Not a pure module */
